import type {MenuItemData} from '@Panels/user-menu-panel/user-menu-panel.types';
import {MenuItemType} from '@Panels/user-menu-panel/user-menu-panel.types';
import {getColumnCountForLayout, getColumnsForLayout} from '@PosterWhiteboard/items/layouts/layout.library';
import type {CellObject} from '@PosterWhiteboard/items/layouts/cells/cell';
import {Cell} from '@PosterWhiteboard/items/layouts/cells/cell';
import type {LayoutData} from '@Panels/user-schedule-panel/user-schedule-panel.types';
import type {MenuItem, MenuItemObject} from '@PosterWhiteboard/items/menu-item/menu-item.class';
import cloneDeep from 'lodash/cloneDeep'
import type {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import type {CellType} from "@PosterWhiteboard/items/layouts/cells/cell.types";

export const prepareDataForMenuItem = (items: MenuItemData[], layout: string): Partial<MenuItemObject> => {
  const menuLayout: Record<string, CellObject[]> = cloneDeep(getColumnsForLayout(layout as LayoutTypes));
  const columnIds = Object.keys(menuLayout) as CellType[];

  columnIds.forEach((columnId) => {
    for (let i = 0; i < items.length; i++) {
      const val = items[i][columnId as keyof MenuItemData] ?? false;
      menuLayout[columnId].push(new Cell(columnId, val).toObject());
    }
  });

  const menuItemIds = items.map((item) => {
    return item.id;
  });

  return {
    layoutDataMap: menuLayout,
    rows: items.length,
    columns: getColumnCountForLayout(layout as LayoutTypes),
    itemIds: menuItemIds,
    layoutStyle: layout as LayoutData,
  };
};

export const getSelectedMenuItems = (menuItem: MenuItem): MenuItemData[] => {
  const selectedItems = [];
  const menuData = menuItem.layoutDataMap;
  for (let i = 0; i < menuItem.itemIds.length; i++) {
    selectedItems.push({
      type: MenuItemType.USER_MENU_ITEM,
      id: menuItem.itemIds[i],
      name: menuData.name?.[i].getValue(),
      description: menuData.description?.[i].getValue(),
      price: menuData.price?.[i].getValue(),
      iconsList: menuData.iconsList?.[i].getValue(),
      variationsList: menuData.variationsList ? menuData.variationsList[i].getValue() : menuData.sizesList?.[i].getValue(),
      addOnsList: menuData.addOnsList?.[i].getValue(),
      categories: [],
      locations: [],
    } as MenuItemData);
  }
  return selectedItems;
};
